import React from 'react';

import { observer } from 'mobx-react';

import EventItem from 'ui/Feed/EventItem';

import { TaskStatusNames } from 'utils/api/modules/tasks/tasks.constants';

import { StatusProps } from './types';

const Status: React.FunctionComponent<StatusProps> = ({ activity, sessionUser }) => (
  <EventItem activity={activity} sessionUser={sessionUser}>
    changed status to {TaskStatusNames[activity.status]}
  </EventItem>
);

export default observer(Status);
